import AreYouHealthyComponent from './AreYouHealthy.vue';

export const areyouhealthyRoutes = {
  path: '/areyouhealthy',
  name: 'AreYouHealthy',
  component: AreYouHealthyComponent,
  meta: {
    title: 'Are you healthy'
  }
};
